<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-6">Sources Frequently Cited</h1>
<p class="bib-item">Karl Barth, <em>Church Dogmatics</em>, 13 vols., various translators (Edinburgh: T&amp;T Clark, 1936–1969).</p>
<p class="bib-item"><em>The Book of Confessions</em>, Presbyterian Church (USA) (Louisville: Office of the General Assembly, 1999).</p>
<p class="bib-item">John Calvin, <em>Institutes of the Christian Religion</em>, 2 vols., ed. John T. McNeill (Philadelphia: Westminster, 1960).</p>
<p class="bib-item"><em>Luther’s Works</em>, 55 vols., gen. eds. Jaroslav Pelikan and Helmut T. Lehman (St. Louis: Concordia; Philadelphia: Fortress, 1955–1986).</p>
<p class="bib-item">Paul Tillich, <em>Systematic Theology</em>, 3 vols. (Chicago: University of Chicago Press, 1951–1963).</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 011_Sources.vue?a085272e